
export function organizeNumberOfStops(numberOfStops: number, stops: string): string { 
    switch (numberOfStops){
      case 0:
        return "Direct";
      case 1:
        return `1 ${stops}`;
      case 2:
        return `2 ${stops}`;
      default:
        return `${numberOfStops} ${stops}`;
    }
  }